const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading',
    name: 'Name',
    noFarms: 'No Farms',
    noMoreFarms: 'No More Farms'
};

export default translations;
